import { DetailsResolver } from '@core/resolvers';
import { HttpService } from '@core/services';
import {
  PermittingHttpService,
  ProjectCategoryHttpService,
} from '@core/services/http';
import { getProjectBundleIDParamFromUrl } from '@core/utils/methods';
import { OptionProps } from '@models/interfaces';
import store from '@store/index';

export class PermittingDetailsResolver extends DetailsResolver {
  private get _permittingUsersOptions(): OptionProps[] {
    return store.getState().permitting.permittingUsersOptions;
  }

  async resolve(): Promise<void> {
    const [projectBundleID] = getProjectBundleIDParamFromUrl();

    await Promise.all([
      HttpService.getHttpRequests(
        PermittingHttpService,
      ).getProjectCategoriesByBundleId(projectBundleID),
      HttpService.getHttpRequests(
        PermittingHttpService,
      ).getPermittingSummaryData(projectBundleID),
      HttpService.getHttpRequests(
        ProjectCategoryHttpService,
      ).getProjectCategories(),
    ]);

    if (!this._permittingUsersOptions.length) {
      HttpService.getHttpRequests(
        PermittingHttpService,
      ).getPermittingUsersOptions();
    }
  }
}
